import React from "react";
import HubShell from "../../Components/Common/HubShell";
import Feedback from "../Feedback";
import FormSubmissions from "../FormSubmissions";

document.title = "Voice of User | BiorGov Admin";

// User feedback (suggestions / bugs / dislikes) and inbound form submissions.
// Notifications moved to "In the app" › Notifications (/notifications) with the
// other sections that publish into the app (ADMIN_PANEL_MAP.md, 2026-10-28).
const TABS = [
  { id: "feedback",      label: "Feedback & Bugs",  icon: "ri-bug-line",            perm: "feedback.view",         render: () => <Feedback embedded /> },
  { id: "forms",         label: "Form Submissions", icon: "ri-inbox-line",          perm: "form_submissions.view", render: () => <FormSubmissions embedded /> },
];

const Voice = () => <HubShell title="Voice of User" pageTitle="Product" tabs={TABS} />;

export default Voice;
